import { identity, pickBy } from "lodash";

export const formDateEventPayload = ({ prevDate, ...rest }: { prevDate: Date } & any) =>
    // cleanup empty/false values from event payload
    pickBy(
        {
            "was empty": !prevDate,
            ...rest,
        },
        identity
    );
